import { inject, Injectable } from '@angular/core';
import { filter } from 'rxjs';
import { PerformSyncNotifySource } from '@models/types/perform-sync-notify-source.type';
import { NetworkService } from '@services/network/network.service';
import { PerformSyncService } from '../perform-sync/perform-sync.service';
import { Environment } from '@environment/environment';
import { EnvironmentNames } from '@environment/environment.enum';
declare let IdleDetector: any;

@Injectable({
    providedIn: 'root',
})
export class PerformSyncNotifierService {

    private readonly networkSvc: NetworkService = inject(NetworkService);
    private readonly performSyncSvc = inject(PerformSyncService);

    constructor() {
        this.#notifyWhenOnline();
    }

    #notifyWhenOnline(): void {
        this.networkSvc.networkStatusObs
            .pipe(filter((status) => status === 'online'))
            .subscribe((status : 'online') => {
                this.notifyPerformSyncNotifier(status);
            });
    }

    public notifyPerformSyncNotifier(performSyncNotifySource: PerformSyncNotifySource): void {
        if (this.networkSvc.isOnline == false) {
            return;
        }
        if(Environment.environment == EnvironmentNames.local) {
            console.log('PerformSyncNotifierService: notifyPerformSyncNotifier : ', performSyncNotifySource);
        }
        this.performSyncSvc.startSync({
            syncType : 'up-sync-only'
        });
    }

    public registerIdleDetection(screenState: 'locked' | 'unlocked', userState: 'active' | 'idle') {
        if(screenState == 'locked') {
            this.notifyPerformSyncNotifier('screen-lock');
            return
        }
        if(userState == 'idle') {
            this.notifyPerformSyncNotifier('idle');
            return
        }
    }
}
